// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"34":"fcf57395","425":"accb7b7c","510":"0df48187","532":"414d80e7","633":"1e23a86f","634":"64d9ca2e","922":"dbc55708","937":"01c8ccb6","972":"a4427543"}[chunkId] + ".chunk.js";
};